import { makeGetAllCoursesUser } from 'main/factories/usecases/courses/remote-get-all-courses-user-factory';
import { makeGetAllCurricularUnitsUser } from 'main/factories/usecases/curricular-units/remote-get-all-curricular-units-user-factory';
import { makeGetAllUsersMetrics } from 'main/factories/usecases/dashboard/remote-get-all-users-metrics-factory';
import { makeGetAllGroupsUser } from 'main/factories/usecases/groups/remote-get-all-groups-user-factory';
import { makeGetAllOrganizationsUser } from 'main/factories/usecases/organizations/remote-get-all-organizations-user-factory';
import { makeGetAllSemestersUser } from 'main/factories/usecases/semesters/remote-get-all-semesters-user-factory';
import { Dashboard } from 'presentation/app/modules/Dashboard/pages/dashboard';
import React from 'react';

export const MakeDashboard: React.FC = () => {
  return (
    <Dashboard
      getAllGroupsUser={makeGetAllGroupsUser()}
      getAllCoursesUser={makeGetAllCoursesUser()}
      getAllSemestersUser={makeGetAllSemestersUser()}
      getAllOrganizationsUser={makeGetAllOrganizationsUser()}
      getAllCurricularUnitsUser={makeGetAllCurricularUnitsUser()}
      getAllUsersMetrics={makeGetAllUsersMetrics()}
    />
  );
};
